import { Outlet, useLocation } from 'react-router-dom'
import usePageMeta from './usePageMeta'
import { canonicalUrl, isNoindexPath } from './routes'

/**
 * Route-level head defaults, mounted once at the root of the router: the
 * canonical URL for the current path and `noindex` on every private area,
 * token link and sign-in page (seo/routes.js NOINDEX_PREFIXES). Pages
 * refine the rest with usePageMeta.
 */
export default function RouteHead() {
  const { pathname } = useLocation()
  usePageMeta(
    { canonical: canonicalUrl(pathname), noindex: isNoindexPath(pathname) },
    0
  )
  return <Outlet />
}
